import React, { useEffect, useRef, useState } from "react";
import "./overViewBPreview.scss";
import { BeditOverviewData } from "../../../../components/Data/bEditData";
import RadioButton from "../../../../components/RadioButton/RadioButton";
import {
  bookmark_black,
  editIconBlue,
  employeesBlack,
  locationOrange,
  orangeRightTick,
  suitCase_black,
  sustainableLeafIcon,
} from "../../../../images";
import { Link } from "react-router-dom";
import AboutPopupView from "../../BusinessProfileComponents/BusinessViewPopups/AboutPopupView/AboutPopupView";
import { Rating } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useWindowSize } from "react-use";
import WriverChat from "../AskChat/AskChat";
import AskChat from "../AskChat/AskChat";
import useTheme from "../../../../components/useTheme/useTheme";

const OverView = ({
  isActive,
  isSubtabActive,
  ctaText,
  editIcon,
  overviewData,
  handleShowLocation,
  containerRef,
  scrollingText,
  handleShow,
  workflowQuestions,
}) => {
  const { theme } = useTheme();
  const [isAboutPopup, setIsAboutPopup] = useState(false);
  const swiperRef = useRef(null);
  const { width } = useWindowSize();
  const handleShowAbout = () => setIsAboutPopup(true);
  const handleHideAbout = () => setIsAboutPopup(false);
  const [isAboutExpanded, setIsAboutExpanded] = useState(false);
  const handleToggleAbout = () => setIsAboutExpanded(!isAboutExpanded);
  const [isExcelExpanded, setIsExcelExpanded] = useState(false);
  const handleToggleExcelExpanded = () => setIsExcelExpanded(!isExcelExpanded);
  const [isFocusExpanded, setIsFocusExpanded] = useState(false);
  const handleToggleFocusExpanded = () => setIsFocusExpanded(!isFocusExpanded);
  const servicesTrackRef = useRef(null);
  const servicesAnimFrameRef = useRef(null);

  // Scrolling animation for collapsed featured services
  useEffect(() => {
    if (isAboutExpanded) {
      if (servicesAnimFrameRef.current) {
        cancelAnimationFrame(servicesAnimFrameRef.current);
        servicesAnimFrameRef.current = null;
      }
      return;
    }

    const track = servicesTrackRef.current;
    if (!track) return;

    let offset = 0;
    const speed = 0.5;

    const animate = () => {
      offset -= speed;
      const width = track.scrollWidth / 2;
      if (Math.abs(offset) >= width) {
        offset = 0;
      }
      track.style.transform = `translateX(${offset}px)`;
      servicesAnimFrameRef.current = requestAnimationFrame(animate);
    };

    servicesAnimFrameRef.current = requestAnimationFrame(animate);
    return () => {
      if (servicesAnimFrameRef.current) {
        cancelAnimationFrame(servicesAnimFrameRef.current);
      }
    };
  }, [isAboutExpanded]);
  const ratingContainerRef = useRef(null);

  useEffect(() => {
    const slider = ratingContainerRef.current;
    if (!slider) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    const handleMouseDown = (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    };

    const handleMouseLeave = () => {
      isDown = false;
      slider.classList.remove("active");
    };

    const handleMouseUp = () => {
      isDown = false;
      slider.classList.remove("active");
    };

    const handleMouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2;
      slider.scrollLeft = scrollLeft - walk;
    };

    const handleKeyDown = (e) => {
      if (e.key === "ArrowLeft") {
        slider.scrollBy({ left: -100, behavior: "smooth" });
      } else if (e.key === "ArrowRight") {
        slider.scrollBy({ left: 100, behavior: "smooth" });
      }
    };

    slider.addEventListener("mousedown", handleMouseDown);
    slider.addEventListener("mouseleave", handleMouseLeave);
    slider.addEventListener("mouseup", handleMouseUp);
    slider.addEventListener("mousemove", handleMouseMove);
    slider.addEventListener("keydown", handleKeyDown);
    slider.tabIndex = 0;

    return () => {
      slider.removeEventListener("mousedown", handleMouseDown);
    };
  }, []);

  // Ref for focus_wrapper drag-to-scroll
  const focusWrapperRef = useRef(null);
  const shouldRenderField = (fieldKey) => {
    if (!workflowQuestions || !overviewData?.business_types) {
      return false;
    }

    const question = workflowQuestions.find((q) => q.question === fieldKey);
    if (!question) {
      return false;
    }

    const userBusinessTypeIds = overviewData.business_types.map((bt) => bt._id);
    const questionBusinessTypeIds = question.business_types.map((bt) => bt._id);

    return userBusinessTypeIds.some((id) =>
      questionBusinessTypeIds.includes(id)
    );
  };

  // Drag-to-scroll logic for focus_wrapper
  useEffect(() => {
    const slider = focusWrapperRef.current;
    if (!slider) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    const handleMouseDown = (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    };

    const handleMouseLeave = () => {
      isDown = false;
      slider.classList.remove("active");
    };

    const handleMouseUp = () => {
      isDown = false;
      slider.classList.remove("active");
    };

    const handleMouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2; // Scroll speed multiplier
      slider.scrollLeft = scrollLeft - walk;
    };

    const handleKeyDown = (e) => {
      if (e.key === "ArrowLeft") {
        slider.scrollBy({ left: -100, behavior: "smooth" }); // Scroll left by 100px
      } else if (e.key === "ArrowRight") {
        slider.scrollBy({ left: 100, behavior: "smooth" }); // Scroll right by 100px
      }
    };

    slider.addEventListener("mousedown", handleMouseDown);
    slider.addEventListener("mouseleave", handleMouseLeave);
    slider.addEventListener("mouseup", handleMouseUp);
    slider.addEventListener("mousemove", handleMouseMove);
    slider.addEventListener("keydown", handleKeyDown);

    // Ensure slider is focusable for key events
    slider.tabIndex = 0;

    return () => {
      slider.removeEventListener("mousedown", handleMouseDown);
      slider.removeEventListener("mouseleave", handleMouseLeave);
      slider.removeEventListener("mouseup", handleMouseUp);
      slider.removeEventListener("mousemove", handleMouseMove);
      slider.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const overviewDataMapped = [
    {
      about: [
        {
          title: "About",
          ctaText: isAboutExpanded ? "View Less" : "View More",
          desc: [`${overviewData?.bio}`],
        },
      ],
      products: [
        {
          title: "Products/Services",
          radioField: overviewData?.featured_services,
          allServices: (() => {
            const featured = overviewData?.featured_services || [];
            const featuredSet = new Set(featured.map(s => s?.trim?.()?.toLowerCase?.()));
            const remaining = (overviewData?.services || []).filter(
              (s) => !featuredSet.has(s?.trim?.()?.toLowerCase?.())
            );
            return [...featured, ...remaining];
          })(),
        },
      ],
      focus: [
        {
          title: "Our Focus",
          ctaText: "Edit | View",
          focusData: overviewData?.product_positionings,
        },
      ],
    },
  ];

  const hasExcelData =
    (shouldRenderField("project_typology") &&
      overviewData?.project_typology?.data?.length > 0) ||
    (shouldRenderField("service_design_style") &&
      overviewData?.design_style?.data?.length > 0);

  console.log("overviewData", overviewData);

  return (
    <>
      <AboutPopupView
        show={isAboutPopup}
        onHide={() => setIsAboutPopup(false)}
        handleClose={handleHideAbout}
        data={overviewData}
        workflowQuestions={workflowQuestions}
      />
      <div
        className="profile_overview_container profile__overview--container
"
      >
        <div className="my_container p-0">
          <div className={`overview_container `}>
            {/* {BeditProfileData[isActive]?.subTab?.map( */}
            {overviewDataMapped.map(
              (data, index) =>
                data?.about && (
                  <div
                    className={`data_container ${
                      isSubtabActive === index ? "active" : ""
                    }`}
                    key={index}
                  >
                    {/* SECTION 1: About */}
                    {overviewData?.bio?.trim()?.length > 0 &&
                      data?.about?.map((about, i) => (
                        <div className={`about_container`} key={`about-${i}`}>
                          <div className="text_container">
                            <div className="cta_container">
                              <h2 className="title">{about.title}</h2>
                              <div
                                className="cta_wrapper p-0"
                                // onClick={handleShowAbout}
                                onClick={
                                  width > 992
                                    ? handleToggleAbout
                                    : handleShowAbout
                                }
                              >
                                {editIcon && (
                                  <img
                                    src={editIconBlue}
                                    alt="edit icon"
                                    className="edit_icon"
                                  />
                                )}
                                <Link
                                  to={() => false}
                                  className="bedit_common_cta"
                                >
                                  {about.ctaText}
                                </Link>
                              </div>
                            </div>
                            {/* Since year - right below About heading */}
                            {overviewData?.establishment_year?.data && (
                              <p className="establishment_year_text">
                                Since : {overviewData.establishment_year.data}
                              </p>
                            )}
                            {about?.desc?.map((item, i) => (
                              <p
                                className={`desc ${
                                  isAboutExpanded ? "expanded_container" : ""
                                }`}
                                dangerouslySetInnerHTML={{ __html: item }}
                                key={i}
                              ></p>
                            ))}
                          </div>
                        </div>
                      ))}

                    {/* SECTION 2: Locations + Employees (merged with About) */}
                    {overviewData?.addresses?.length > 0 && (
                      <div className="select_field_container" style={{ position: "relative" }}>
                        {/* <h2 class="sub_title heding_loc_bview">Locations</h2> */}
                        {(isAboutExpanded
                          ? overviewData?.addresses
                          : overviewData?.addresses?.slice(0, 1)
                        )?.map((address, index) => (
                          <div key={index} className="wrp_st_loc_bview_item">
                            <div className="wrp_st_loc_bview">
                              <p className="select_title">
                                {" "}
                                <img
                                  src={locationOrange}
                                  alt="location"
                                  className="location_icon"
                                />
                                Location :
                              </p>
                              <div
                                className="select_field"
                                // onClick={handleShowLocation}
                              >
                                {address?.address}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {overviewData?.team_range?.data && (
                      <div className="rating_container">
                        <div className="rating_status">
                          <img
                            src={employeesBlack}
                            alt="verified"
                            className="emp_icon"
                          />
                          <p className="rating_text">
                            {overviewData?.team_range?.data} Employees
                          </p>
                        </div>
                      </div>
                    )}

                    {/* SECTION 3: Products/Services */}
                    {overviewData?.services?.length > 0 &&
                      data?.products?.map((product, i) => (
                        <div
                          className="product_container prd_cont_serv"
                          key={`product-${i}`}
                        >
                          {!isAboutExpanded ? (
                            <div className="scrolling-services-wrapper">
                              <div className="scrolling-services-track" ref={servicesTrackRef}>
                                {[...(product?.radioField || []), ...(product?.radioField || [])].map((radio, index) => (
                                  <span key={`scroll-${index}`} className="service-pill">
                                    {radio}
                                  </span>
                                ))}
                              </div>
                            </div>
                          ) : (
                            <ul className="list_wrapper ul_wr_radio">
                              {(product?.allServices || product?.radioField
                              )?.map((radio, index) => (
                                  <RadioButton
                                    label={radio}
                                    labelId={`radio-${index}`}
                                    lightTheme
                                    className={"test"}
                                    key={`radio-${index}`}
                                    disabled={true}
                                  ></RadioButton>
                                ))}
                            </ul>
                          )}
                        </div>
                      ))}

                    {/* SECTION 4: Our Focus */}
                    {(overviewData.product_positionings?.length > 0 ||
                      overviewData?.renovation_work === true ||
                      overviewData?.project_location?.data ||
                      overviewData?.project_sizes?.sizes?.length > 0) &&
                      data?.focus?.map((data, i) => (
                        <div className="scroll_text_container focus_scroll_container" key={`focus-${i}`}>
                          <div className="wraper_scroling_txt">
                            <div className="title">Our Focus</div>
                            {!isFocusExpanded ? (
                              <>
                                {data?.focusData?.length > 0 && (
                                  <div className="focus_wrapper" ref={focusWrapperRef}>
                                    {data.focusData.map((item, index) => (
                                      <div className="focus_box" key={index}>
                                        {item !== "Sustainable" ? (
                                          <img
                                            src={orangeRightTick}
                                            alt="right tick"
                                            className="focus_img"
                                          />
                                        ) : (
                                          <img
                                            src={sustainableLeafIcon}
                                            alt="right tick"
                                            className="focus_img"
                                          />
                                        )}
                                        <p className="focus_title">{item}</p>
                                      </div>
                                    ))}
                                  </div>
                                )}
                                {(() => {
                                  const focusTexts = [
                                    shouldRenderField("renovation_work") &&
                                      (overviewData?.renovation_work === true || overviewData?.renovation_work === "true") &&
                                      `Renovation Work : <span>Yes</span>`,
                                    shouldRenderField("location_preference") &&
                                      overviewData?.project_location?.data &&
                                      `Location Preference : <span>${overviewData.project_location.data}</span>`,
                                    shouldRenderField("minimum_project_size") &&
                                      overviewData?.project_sizes?.sizes?.length > 0 &&
                                      `Min. Project Size : <span>${overviewData.project_sizes.sizes
                                        .map((size) => `${size} ${overviewData?.project_sizes?.unit}`)
                                        .join(", ")}</span>`,
                                  ].filter(Boolean);
                                  return focusTexts.length > 0 ? (
                                    <Swiper
                                      key="focus-swiper-view"
                                      direction={"vertical"}
                                      className="scroll_text_slider focus_scroll_text_slider"
                                      effect="slide"
                                      loop={true}
                                      modules={[Autoplay]}
                                      speed={1200}
                                      autoplay={{
                                        delay: 2000,
                                        disableOnInteraction: false,
                                      }}
                                      observer={true}
                                      observeParents={true}
                                    >
                                      {focusTexts.map((item, idx) => (
                                        <SwiperSlide key={idx}>
                                          <p
                                            className="scrolling_text"
                                            dangerouslySetInnerHTML={{ __html: item }}
                                          ></p>
                                        </SwiperSlide>
                                      ))}
                                    </Swiper>
                                  ) : null;
                                })()}
                              </>
                            ) : (
                              <ul className="common_ul_popups">
                                {data?.focusData?.length > 0 && (
                                  <li className="common_li_popup common_multi_line_list">
                                    Market Positioning :
                                    <div className="pills_common_li_popup mt-3">
                                      {data.focusData.map((it, idx) => (
                                        <div key={idx} className="pill_span_li">
                                          {it}
                                        </div>
                                      ))}
                                    </div>
                                  </li>
                                )}
                                {shouldRenderField("renovation_work") &&
                                  (overviewData?.renovation_work === true || overviewData?.renovation_work === "true") && (
                                  <li className="common_li_popup">
                                    <div className="wrp_ov_text">
                                      Renovation Work :
                                    </div>
                                    <span className="bold_common_li_popup">
                                      Yes
                                    </span>
                                  </li>
                                )}
                                {shouldRenderField("location_preference") &&
                                  overviewData?.project_location?.data && (
                                  <li className="common_li_popup">
                                    <div className="wrp_ov_text">
                                      Location Preference :
                                    </div>
                                    <span className="bold_common_li_popup">
                                      {overviewData.project_location.data}
                                    </span>
                                  </li>
                                )}
                                {shouldRenderField("minimum_project_size") &&
                                  overviewData?.project_sizes?.sizes?.length > 0 && (
                                  <li className="common_li_popup">
                                    <div className="wrp_ov_text">
                                      Min. Project Size :
                                    </div>
                                    <span className="bold_common_li_popup">
                                      {overviewData.project_sizes.sizes
                                        .map(
                                          (size) =>
                                            `${size} ${overviewData?.project_sizes?.unit}`
                                        )
                                        .join(", ")}
                                    </span>
                                  </li>
                                )}
                              </ul>
                            )}
                          </div>
                          {width > 992 && (
                            <div
                              className="bedit_common_cta position-absolute"
                              style={{
                                right: "0",
                                cursor: "pointer",
                              }}
                              onClick={handleToggleFocusExpanded}
                            >
                              {isFocusExpanded ? "View Less" : "View More"}
                            </div>
                          )}
                        </div>
                      ))}

                    {/* SECTION 5: Where We Excel */}
                    {hasExcelData && (
                      <div className="scroll_text_container">
                        <div className="wraper_scroling_txt">
                          <div className="title">
                            Where We Excel
                          </div>
                          {!isExcelExpanded ? (
                            <Swiper
                              direction={"vertical"}
                              className="scroll_text_slider"
                              effect="slide"
                              loop={true}
                              modules={[Autoplay]}
                              observer={true}
                              observeParents={true}
                              onSwiper={(swiper) => {
                                swiperRef.current = swiper;
                              }}
                              speed={1500}
                              autoplay={{
                                delay: 1000,
                                disableOnInteraction: false,
                              }}
                            >
                              {scrollingText}
                            </Swiper>
                          ) : (
                            <ul className="common_ul_popups">
                              {shouldRenderField("project_typology") &&
                                overviewData?.project_typology?.data?.length >
                                  0 && (
                                  <li className="common_li_popup common_multi_line_list">
                                    Project Typology :
                                    <div className="pills_common_li_popup mt-3">
                                      {overviewData.project_typology.data.map(
                                        (it, idx) => (
                                          <div
                                            key={idx}
                                            className="pill_span_li pill_style--project-typology"
                                          >
                                            {it}
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </li>
                                )}

                              {shouldRenderField("service_design_style") &&
                                overviewData?.design_style?.data?.length >
                                  0 && (
                                  <>
                                    <li className="common_li_popup common_multi_line_list extra_mb">
                                      Design Style :
                                    </li>
                                    <div className="pills_common_li_popup">
                                      {overviewData.design_style.data.map(
                                        (it, idx) => (
                                          <div
                                            key={idx}
                                            className="pill_span_li"
                                          >
                                            {it}
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </>
                                )}
                            </ul>
                          )}
                        </div>
                        {width > 992 && (
                          <div
                            className="bedit_common_cta position-absolute"
                            style={{
                              right: "0",
                              cursor: "pointer",
                            }}
                            onClick={handleToggleExcelExpanded}
                            // onClick={handleShow}
                          >
                            {isExcelExpanded ? "View Less" : "View More"}
                          </div>
                        )}
                      </div>
                    )}

                    {/* Empty rating_container removed — all children were commented out,
                        but the div still rendered a border-bottom divider on mobile */}
                  </div>
                )
            )}
            {/* <AskChat /> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default OverView;
